// @flow
import * as React from 'react';
import styled, {keyframes} from 'styled-components';
import {LocalText} from 'components/Localized';
import { HeaderPaddingTop, HeaderPaddingTopLandscape } from 'components/Constants';

type Props = {
  hidden: boolean,
  dataFullScreen: boolean,
  onOpenSelection: () => void,
};

export default function Header(props: Props): React.Element<any> {
  return (
    <Title dataFull={props.dataFullScreen}>
      <LocalText textKey="showroom_title" />
    </Title>
  );
}

const fullscreenOnAnimation = keyframes`
  0% { transform: translateY(0px); opacity: 1; }
  100% { transform: translateY(-100px); opacity: 0;}
`;

const fullscreenOffAnimation = keyframes`
  0% { transform: translateY(-100px); opacity: 0;}
  100% { transform: translateY(0px); opacity: 1;}
`;

const Title = styled.div`
  position: absolute;
  width: 100%;
  left: 0px;
  top: 0px;
  text-align: center;

  padding-top: ${(props: any) => (!props.theme.layout.mobile ? HeaderPaddingTop.desktop : (props.theme.layout.portrait ? HeaderPaddingTop.mobile : HeaderPaddingTopLandscape.mobile))}px;

  animation-name: ${(props: any) =>
    props.dataFull === undefined
      ? 'undefind'
      : props.dataFull
      ? fullscreenOnAnimation
      : fullscreenOffAnimation};
  animation-duration: 0.25s;

  > span {
    font-size: ${(props: any) => props.theme.layout.mobile && props.theme.layout.portrait ? '36px' : undefined};
    line-height: ${(props: any) => props.theme.layout.mobile && props.theme.layout.portrait ? '43px' : undefined};
  }
`;
